import classNames from "classnames";

export const container = classNames(
    // Mobile
    "mobile:w-auto",
    "mobile:px-8",
    "mobile:pt-4",
    "mobile:pb-2",
    // Tablet
    "tablet:bg-[url(/assets/images/backgrounds/support/x-desktop.svg)]",
    // "tablet:bg-[position:10px_-60px]",
    "tablet:bg-left",
    "tablet:bg-no-repeat",
    "tablet:p-12",
    "tablet:ml-2",
    // All
    "w-full",
    "flex",
    "flex-col",
    "items-center",
    "justify-center",
)

export const heading = classNames(
    // Mobile
    "mobile:",
    // Tablet
    "tablet:",
   // All
);

export const subheading = classNames(
    // Mobile
    "mobile:text-md",
    "mobile:pt-2",
    "mobile:",
    // Tablet
    "tablet:text-2xl",
    "tablet:pt-4"
    // All
);

export const contactDetailsContainer = classNames(
    "flex",
    "justify-center",
    "items-center"
)

export const emailDetails = classNames(
    // Mobile
    "mobile:mt-6",
    // Tablet
    "tablet:mt-8",
    // All
    "flex",
    "flex-col",
    "items-center",
    "justify-center",
);
export const emails = classNames(
    // Mobile
    "mobile:text-sm",
    // Tablet
    "tablet:text-2xl",
    // All
    "flex",
    "items-center",
    "justify-start",
    "mb-5",
);

export const phoneDetails = classNames(
    // Mobile
    "mobile:mt-2",
    // Tablet
    "tablet:mt-4",
    // All
    "flex",
    "flex-row",
    "items-center",
    "justify-center",
);
export const contactNumber = classNames(
    // Mobile
    "mobile:text-sm",
    "mobile:pr-4",
    "mobile:mb-4",
    // Tablet
    "tablet:text-2xl",
    "tablet:pr-8",
    "tablet:mb-0",
    // All
    "flex",
    "items-center",
    "justify-center",
);

export const contactIcon = classNames(
    // Mobile
    "mobile:w-4",
    "mobile:mr-2",
    // Tablet
    "tablet:w-6",
    "tablet:mr-4",
    // All
    "cursor-pointer"
);

